import LineMenuIcon from "@icons/lineMenuIcon.svg";
import styles from "./filterMenu.module.scss";
import { ActionSheet } from "@kunduz/ui-molecules";
import { Button, Text } from "@kunduz/ui-atoms";

export const FilterMenu = (props: Props) => {
  return (
    <div className={styles["filterMenu"]}>
      {props.isMobile ? (
        <ActionSheet
          withPortal
          trigger={
            <Button variant="primary" color="blue" size="lg">
              <LineMenuIcon />
              <Text variant="textsm" weight="medium">
                {props.hamburgerMenuLabel}
              </Text>
            </Button>
          }
        >
          {props.renderMenu()}
        </ActionSheet>
      ) : (
        <>{props.renderMenu()}</>
      )}
    </div>
  );
};

interface Props {
  isMobile: boolean;
  renderMenu: () => JSX.Element;
  hamburgerMenuLabel: string;
  isOpen: boolean;
  setOpen: (e: boolean) => void;
}
